(function () {
  function initFaq(root) {
    var items = root.querySelectorAll('.bruku-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.bruku-faq-question');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('.bruku-faq-question');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  document.querySelectorAll('.bruku-faq').forEach(initFaq);
})();
